import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CallToAction = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-secondary text-secondary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          <div className="bg-card/10 backdrop-blur-sm rounded-lg p-6 md:p-8 lg:p-10 border-2 border-primary/20">
            <div className="flex items-center space-x-3 mb-4 md:mb-6">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Search" size={24} color="white" strokeWidth={2} className="md:w-7 md:h-7" />
              </div>
              <h3 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl">
                Need a Trailer?
              </h3>
            </div>

            <p className="font-body text-base md:text-lg text-secondary-foreground/80 mb-6 md:mb-8">
              Browse thousands of trailers available for rent in your area. Find the perfect match for your hauling needs with instant booking.
            </p>

            <ul className="space-y-3 mb-6 md:mb-8">
              <li className="flex items-center space-x-3">
                <Icon name="Check" size={20} color="var(--color-success)" strokeWidth={2.5} />
                <span className="font-body text-sm md:text-base">Search by location and dates</span>
              </li>
              <li className="flex items-center space-x-3">
                <Icon name="Check" size={20} color="var(--color-success)" strokeWidth={2.5} />
                <span className="font-body text-sm md:text-base">Compare prices and features</span>
              </li>
              <li className="flex items-center space-x-3">
                <Icon name="Check" size={20} color="var(--color-success)" strokeWidth={2.5} />
                <span className="font-body text-sm md:text-base">Book instantly online</span>
              </li>
            </ul>

            <button
              onClick={() => navigate('/search-results')}
              className="w-full px-6 py-3 md:px-8 md:py-4 bg-primary text-primary-foreground font-body font-medium text-base md:text-lg rounded-md transition-smooth hover:opacity-90 shadow-elevation-2"
            >
              Find a Trailer
            </button>
          </div>

          <div className="bg-card/10 backdrop-blur-sm rounded-lg p-6 md:p-8 lg:p-10 border-2 border-accent/20">
            <div className="flex items-center space-x-3 mb-4 md:mb-6">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-accent rounded-lg flex items-center justify-center">
                <Icon name="Plus" size={24} color="black" strokeWidth={2.5} className="md:w-7 md:h-7" />
              </div>
              <h3 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl">
                Own a Trailer?
              </h3>
            </div>

            <p className="font-body text-base md:text-lg text-secondary-foreground/80 mb-6 md:mb-8">
              Turn your idle trailer into a revenue stream. List your trailer and start earning money from rentals in your local community.
            </p>

            <ul className="space-y-3 mb-6 md:mb-8">
              <li className="flex items-center space-x-3">
                <Icon name="Check" size={20} color="var(--color-success)" strokeWidth={2.5} />
                <span className="font-body text-sm md:text-base">Set your own pricing</span>
              </li>
              <li className="flex items-center space-x-3">
                <Icon name="Check" size={20} color="var(--color-success)" strokeWidth={2.5} />
                <span className="font-body text-sm md:text-base">Control your availability</span>
              </li>
              <li className="flex items-center space-x-3">
                <Icon name="Check" size={20} color="var(--color-success)" strokeWidth={2.5} />
                <span className="font-body text-sm md:text-base">Earn passive income</span>
              </li>
            </ul>

            <button
              onClick={() => navigate('/trailer-listing-creation')}
              className="w-full px-6 py-3 md:px-8 md:py-4 bg-accent text-accent-foreground font-body font-medium text-base md:text-lg rounded-md transition-smooth hover:opacity-90 shadow-elevation-2"
            >
              List Your Trailer
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;